(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  const cfg = window.__cartDrawerConfig || {};

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');

  const itemsContainer =
    document.getElementById('cart-drawer-items');

  const emptyState =
    document.getElementById('cart-drawer-empty');

  const footer =
    document.getElementById('cart-drawer-footer');

  const continueShopping =
    document.getElementById('cart-continue-shopping');

  const itemTemplate =
    document.getElementById('cart-item-template');

  const subtotalValue =
    document.getElementById('cart-subtotal-value');

  const tierMessage =
    document.getElementById('cart-tier-message');

  /* Optional elements from your other cart functionality */

  const discountFeedback =
    document.getElementById('cart-discount-feedback');

  const appliedDiscounts =
    document.getElementById('cart-applied-discounts');

  const suggestedOfferEl =
    document.getElementById('cart-suggested-offer');

  const suggestedOfferCodeEl =
    document.getElementById('cart-suggested-offer-code');

  const suggestedOfferSaveEl =
    document.getElementById('cart-suggested-offer-save');

  const suggestedOfferApplyBtn =
    document.getElementById('cart-suggested-offer-apply');

  if (
    !drawer ||
    !overlay ||
    !itemsContainer ||
    !itemTemplate
  ) {
    return;
  }


  /* =========================================================
     STATE
  ========================================================= */

  let cartData = null;
  let busy = false;
  let renderSeq = 0;

  const productCache = new Map();


  /* =========================================================
     MONEY
  ========================================================= */

  function money(cents) {
    return '₹' + (
      Number(cents || 0) / 100
    ).toLocaleString('en-IN', {
      maximumFractionDigits: 2
    });
  }


  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHtml(value) {
    return String(value || '').replace(
      /[&<>'"]/g,
      function (char) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          "'": '&#39;',
          '"': '&quot;'
        }[char];
      }
    );
  }


  /* =========================================================
     BUSY STATE
  ========================================================= */

  function setBusy(next) {

    busy = !!next;

    drawer.classList.toggle(
      'is-busy',
      busy
    );

    /*
      Disable quantity controls while Shopify
      is processing the current request.
    */

    drawer
      .querySelectorAll(
        '.cart-item__qty-btn, .cart-item__remove, .steal-deal-card__add-btn'
      )
      .forEach(function (button) {
        button.disabled = busy;
      });
  }


  /* =========================================================
     FEEDBACK
  ========================================================= */

  function feedback(message, error) {

    if (!discountFeedback) return;

    discountFeedback.textContent =
      message || '';

    discountFeedback.classList.toggle(
      'is-error',
      !!error
    );
  }


  /* =========================================================
     PRODUCT HANDLE
  ========================================================= */

  function getHandle(item) {

    if (item && item.handle) {
      return item.handle;
    }

    const match = String(
      item && item.url || ''
    ).match(
      /\/products\/([^?/#]+)/
    );

    return match
      ? match[1]
      : '';
  }


  /* =========================================================
     PRODUCT META
  ========================================================= */

  async function getMeta(item) {

    const handle =
      getHandle(item);

    if (!handle) {
      return null;
    }

    if (!productCache.has(handle)) {

      productCache.set(
        handle,

        fetch(
          '/products/' +
          encodeURIComponent(handle) +
          '.js',
          {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          }
        )
          .then(function (response) {
            return response.ok
              ? response.json()
              : null;
          })
          .catch(function () {
            return null;
          })
      );
    }

    const product =
      await productCache.get(handle);

    if (!product) {
      return null;
    }

    const variant =
      (product.variants || []).find(
        function (variant) {
          return String(variant.id) ===
            String(item.variant_id);
        }
      );

    if (!variant) {
      return null;
    }

    return {
      compareAt:
        Number(
          variant.compare_at_price || 0
        ),

      variantTitle:
        variant.title &&
        variant.title !== 'Default Title'
          ? variant.title
          : ''
    };
  }


  /* =========================================================
     RESIZE IMAGE
  ========================================================= */

  function resized(src) {

    if (!src) {
      return '';
    }

    return src.replace(
      /(\.[^.?]+)(\?.*)?$/,
      '_160x200$1$2'
    );
  }


  /* =========================================================
     LOADING STATE
  ========================================================= */

  function showLoadingState() {

    if (emptyState) {
      emptyState.style.display = 'none';
    }

    if (footer) {
      footer.style.display = 'none';
    }

    itemsContainer.innerHTML = `
      <div
        class="cart-drawer__loading"
        role="status"
        aria-live="polite"
      >
        <span
          class="cart-drawer__spinner"
          aria-hidden="true"
        ></span>

        <span>
          Updating your bag…
        </span>
      </div>
    `;
  }


  /* =========================================================
     HEADER LIVE COUNTER
  ========================================================= */

  function updateHeaderCount(count) {

    const total = Number(count || 0);

    /*
      Your custom cart counter
    */
    document
      .querySelectorAll('.clh-cart-count')
      .forEach(function (element) {

        element.textContent = total;

        /*
          Hide counter when cart is empty
        */
        element.hidden = total === 0;

        element.setAttribute(
          'aria-hidden',
          total === 0 ? 'true' : 'false'
        );

        element.setAttribute(
          'aria-label',
          total +
          ' item' +
          (total === 1 ? '' : 's') +
          ' in cart'
        );
      });


    /*
      Other common Shopify cart counters
    */
    const selectors = [
      '.cart-count',
      '.header__cart-count',
      '[data-cart-count]',
      '#cart-count',
      '.cart-item-count',
      '.cart-link__bubble-num',
      '.cart-count-bubble',
      '.cart-count-bubble span'
    ];

    selectors.forEach(function (selector) {

      document
        .querySelectorAll(selector)
        .forEach(function (element) {

          /*
            Don't update our custom counter twice
          */
          if (element.classList.contains('clh-cart-count')) {
            return;
          }

          element.textContent = total;

          element.style.display =
            total > 0
              ? ''
              : 'none';

          element.setAttribute(
            'aria-label',
            total +
            ' item' +
            (total === 1 ? '' : 's') +
            ' in cart'
          );
        });
    });


    /*
      Support data-cart-count-number
    */
    document
      .querySelectorAll('[data-cart-count-number]')
      .forEach(function (element) {

        element.textContent = total;

        element.style.display =
          total > 0
            ? ''
            : 'none';
      });
  }


  /* =========================================================
     TIER / REWARD
  ========================================================= */

  function updateTier(qty) {

    if (!tierMessage) {
      return;
    }

    const tiers =
      Array.isArray(cfg.tierDiscounts)
        ? cfg.tierDiscounts
            .slice()
            .sort(function (a, b) {
              return Number(a.minItems) -
                Number(b.minItems);
            })
        : [];

    let current = null;

    tiers.forEach(function (tier) {

      if (
        qty >=
        Number(tier.minItems || 0)
      ) {
        current = tier;
      }
    });

    const next =
      tiers.find(function (tier) {

        return qty <
          Number(tier.minItems || 0);
      });


    /* =======================================================
       ACTIVE TIER
    ======================================================= */

    document
      .querySelectorAll(
        '.lux-tier'
      )
      .forEach(function (element) {

        element.classList.remove(
          'is-active'
        );
      });


    if (current) {

      const active =
        document.querySelector(
          '.lux-tier[data-tier="' +
          current.tier +
          '"]'
        );

      if (active) {

        active.classList.add(
          'is-active'
        );
      }
    }


    /* =======================================================
       NEXT TIER
    ======================================================= */

    if (next) {

      const need =
        Math.max(
          1,
          Number(next.minItems || 0) -
          qty
        );

      tierMessage.innerHTML =
        'Add <strong>' +
        need +
        '</strong> more item' +
        (need === 1 ? '' : 's') +
        ' to unlock <strong>' +
        Number(next.discount || 0) +
        '% off</strong> with code <strong>' +
        escapeHtml(next.code) +
        '</strong>';

    } else if (current) {

      tierMessage.innerHTML =
        'Quantity offer unlocked: <strong>' +
        Number(current.discount || 0) +
        '% off</strong> with code <strong>' +
        escapeHtml(current.code) +
        '</strong>';

    } else {

      tierMessage.textContent =
        'Add items to unlock your exclusive offer.';
    }
  }


  /* =========================================================
     SELLING SUBTOTAL
  ========================================================= */

  function sellingSubtotal(cart) {

    return (
      cart.items || []
    ).reduce(
      function (sum, item) {

        const linePrice =
          item.original_line_price != null
            ? Number(
                item.original_line_price
              )
            : Number(
                item.original_price ||
                item.price ||
                0
              ) *
              Number(
                item.quantity || 0
              );

        return sum + linePrice;
      },
      0
    );
  }


  /* =========================================================
     DISCOUNT HELPERS
  ========================================================= */

  function appliedCodeObjects(cart) {

    return (
      cart.discount_codes || []
    ).filter(function (discount) {

      return (
        discount &&
        discount.code &&
        discount.applicable !== false
      );
    });
  }


  function allocationTitle(allocation) {

    const application =
      allocation &&
      allocation.discount_application ||
      {};

    return String(
      application.title ||
      application.code ||
      allocation.title ||
      allocation.code ||
      ''
    ).trim();
  }


  function allocationAmount(allocation) {

    return Number(
      allocation &&
      allocation.amount != null
        ? allocation.amount
        : allocation &&
          allocation.total_allocated_amount != null
            ? allocation.total_allocated_amount
            : 0
    );
  }


  function couponSavings(cart) {

    const codes =
      appliedCodeObjects(cart)
        .map(function (discount) {
          return String(
            discount.code
          );
        });

    const wanted =
      new Set(
        codes.map(function (code) {
          return code.toLowerCase();
        })
      );

    const byCode = {};

    codes.forEach(function (code) {
      byCode[
        code.toLowerCase()
      ] = 0;
    });

    let matched = 0;


    function addAllocation(allocation) {

      const amount =
        allocationAmount(
          allocation
        );

      const title =
        allocationTitle(
          allocation
        ).toLowerCase();

      if (
        !amount ||
        !title ||
        !wanted.has(title)
      ) {
        return;
      }

      byCode[title] =
        (
          byCode[title] || 0
        ) + amount;

      matched += amount;
    }


    (
      cart.items || []
    ).forEach(function (item) {

      (
        item.line_level_discount_allocations ||
        item.discount_allocations ||
        []
      ).forEach(
        addAllocation
      );
    });


    (
      cart.cart_level_discount_applications ||
      []
    ).forEach(function (application) {

      const title =
        String(
          application &&
          (
            application.title ||
            application.code ||
            ''
          )
        )
          .trim()
          .toLowerCase();

      const amount =
        Number(
          application &&
          application.total_allocated_amount ||
          0
        );

      if (
        amount &&
        title &&
        wanted.has(title)
      ) {

        byCode[title] =
          (
            byCode[title] || 0
          ) + amount;

        matched += amount;
      }
    });


    /*
      Fallback for one discount code.
    */

    if (
      codes.length === 1 &&
      matched === 0
    ) {

      const totalDiscount =
        Number(
          cart.total_discount || 0
        );

      const selling =
        sellingSubtotal(cart);

      const total =
        Number(
          cart.total_price || 0
        );

      const derived =
        Math.max(
          0,
          selling - total
        );

      const fallback =
        Math.max(
          totalDiscount,
          derived
        );

      if (fallback > 0) {

        byCode[
          codes[0].toLowerCase()
        ] = fallback;

        matched = fallback;
      }
    }

    return {
      total: matched,
      byCode: byCode
    };
  }


  /* =========================================================
     SUMMARY
  ========================================================= */

  async function updateSummary(
    cart,
    sequence
  ) {

    const items =
      cart.items || [];

    const metas =
      await Promise.all(
        items.map(function (item) {
          return getMeta(item)
            .catch(function () {
              return null;
            });
        })
      );


    if (
      sequence !== renderSeq
    ) {
      return;
    }


    const selling =
      sellingSubtotal(cart);


    /*
      Calculate MRP.
    */

    const mrp =
      items.reduce(
        function (
          sum,
          item,
          index
        ) {

          const compare =
            Number(
              metas[index] &&
              metas[index].compareAt ||
              0
            );

          const base =
            Number(
              item.original_price ||
              item.price ||
              0
            );

          const unit =
            compare > base
              ? compare
              : base;

          return sum +
            (
              unit *
              Number(
                item.quantity || 0
              )
            );
        },
        0
      );


    const mrpDiscount =
      Math.max(
        0,
        mrp - selling
      );


    const coupon =
      couponSavings(cart);


    /*
      Shopify's final cart amount.
    */

    const total =
      Number(
        cart.total_price || 0
      );


    /* =======================================================
       SUBTOTAL
    ======================================================= */

    if (subtotalValue) {

      /*
        items_subtotal_price =
        product subtotal before cart-level
        discounts.

        If you want the final discounted
        amount instead, change this to:

        money(cart.total_price)
      */

      const subtotal =
        Number(
          cart.items_subtotal_price != null
            ? cart.items_subtotal_price
            : selling
        );

      subtotalValue.textContent =
        money(subtotal);
    }


    /* =======================================================
       OPTIONAL SUMMARY ELEMENTS
    ======================================================= */

    const mrpEl =
      document.getElementById(
        'cart-total-mrp'
      );

    const mrpDiscountEl =
      document.getElementById(
        'cart-mrp-discount'
      );

    const couponEl =
      document.getElementById(
        'cart-coupon-discount'
      );

    const grandEl =
      document.getElementById(
        'cart-grand-total'
      );

    const savingEl =
      document.getElementById(
        'cart-total-saving'
      );

    const offPctEl =
      document.getElementById(
        'cart-total-off-percent'
      );


    if (mrpEl) {

      mrpEl.textContent =
        money(
          mrp ||
          selling ||
          total
        );
    }


    if (mrpDiscountEl) {

      mrpDiscountEl.textContent =
        mrpDiscount
          ? '−' +
            money(mrpDiscount)
          : money(0);
    }


    if (couponEl) {

      couponEl.textContent =
        coupon.total
          ? '−' +
            money(coupon.total)
          : money(0);
    }


    if (grandEl) {

      grandEl.textContent =
        money(total);
    }


    const totalSaving =
      Math.max(
        0,
        mrp - total
      );


    if (savingEl) {

      savingEl.textContent =
        totalSaving
          ? money(totalSaving) +
            ' Saved so far!'
          : '';

      savingEl.hidden =
        !totalSaving;
    }


    if (offPctEl) {

      const percentage =
        mrp > 0
          ? Math.round(
              (
                (mrp - total) *
                100
              ) / mrp
            )
          : 0;

      offPctEl.textContent =
        percentage > 0
          ? '(' +
            percentage +
            '% OFF)'
          : '';

      offPctEl.hidden =
        percentage <= 0;
    }


    /* =======================================================
       APPLIED DISCOUNTS
    ======================================================= */

    const codes =
      appliedCodeObjects(cart)
        .map(function (discount) {
          return String(
            discount.code
          );
        });


    if (appliedDiscounts) {

      appliedDiscounts.innerHTML =
        codes.length
          ? codes
              .map(function (code) {

                const amount =
                  Number(
                    coupon.byCode[
                      code.toLowerCase()
                    ] || 0
                  );

                return `
                  <button
                    type="button"
                    class="cart-discount-chip"
                    data-remove-discount="${escapeHtml(code)}"
                    aria-label="Remove ${escapeHtml(code)}"
                  >
                    ${escapeHtml(code)}
                    ${
                      amount
                        ? ' · −' +
                          money(amount)
                        : ''
                    }
                    ×
                  </button>
                `;
              })
              .join('')
          : '';
    }


    /* =======================================================
       SUGGESTED COUPON
    ======================================================= */

    if (suggestedOfferEl) {

      const suggested =
        cfg.suggestedCoupon;

      const alreadyApplied =
        suggested &&
        codes.some(function (code) {

          return code.toLowerCase() ===
            String(
              suggested.code || ''
            ).toLowerCase();
        });


      if (
        suggested &&
        suggested.code &&
        Number(suggested.percent) > 0 &&
        selling > 0 &&
        !alreadyApplied
      ) {

        const previewSave =
          Math.round(
            selling *
            Number(
              suggested.percent
            ) /
            100
          );


        if (suggestedOfferCodeEl) {

          suggestedOfferCodeEl.textContent =
            suggested.code;
        }


        if (suggestedOfferSaveEl) {

          suggestedOfferSaveEl.textContent =
            'You save ' +
            money(previewSave);
        }


        suggestedOfferEl.hidden =
          false;

      } else {

        suggestedOfferEl.hidden =
          true;
      }
    }
  }


  /* =========================================================
     CREATE CART ITEM
  ========================================================= */

  function itemNode(
    item,
    index
  ) {

    const fragment =
      itemTemplate.content.cloneNode(
        true
      );

    const card =
      fragment.querySelector(
        '.cart-item'
      );

    if (!card) {
      return fragment;
    }


    const title =
      card.querySelector(
        '.cart-item__title'
      );

    const image =
      card.querySelector(
        '.cart-item__image'
      );

    const price =
      card.querySelector(
        '.cart-item__price'
      );

    const comparePrice =
      card.querySelector(
        '.cart-item__compare-price'
      );

    const quantityValue =
      card.querySelector(
        '.cart-item__qty-value'
      );

    const minusButton =
      card.querySelector(
        '.cart-item__qty-minus'
      );

    const plusButton =
      card.querySelector(
        '.cart-item__qty-plus'
      );

    const removeButton =
      card.querySelector(
        '.cart-item__remove'
      );


    /* =======================================================
       IMPORTANT:
       Use Shopify line item KEY
       ======================================================= */

    card.dataset.lineIndex =
      String(index + 1);

    card.dataset.lineKey =
      item.key || '';


    /* =======================================================
       TITLE
    ======================================================= */

    if (title) {

      title.textContent =
        item.product_title ||
        item.title ||
        '';
    }


    /* =======================================================
       IMAGE
    ======================================================= */

    if (image) {

      image.src =
        resized(item.image);

      image.alt =
        item.product_title ||
        item.title ||
        '';
    }


    /* =======================================================
       PRICE
    ======================================================= */

    const unitPrice =
      Number(
        item.original_price ||
        item.price ||
        0
      );

    const finalPrice =
      Number(
        item.final_price ||
        item.price ||
        0
      );


    if (price) {

      price.textContent =
        money(finalPrice);
    }


    if (comparePrice) {

      comparePrice.hidden =
        true;

      comparePrice.textContent =
        '';
    }


    /* =======================================================
       CURRENT QUANTITY
    ======================================================= */

    const currentQuantity =
      Number(
        item.quantity || 1
      );


    if (quantityValue) {

      quantityValue.textContent =
        currentQuantity;
    }


    /* =======================================================
       MINUS BUTTON
    ======================================================= */

    if (minusButton) {

      minusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          event.stopPropagation();

          if (busy) {
            return;
          }


          const current =
            Number(
              item.quantity || 0
            );


          const newQuantity =
            Math.max(
              0,
              current - 1
            );


          /*
            Shopify line item KEY,
            NOT array index.
          */

          changeLine(
            item.key,
            newQuantity
          );
        }
      );
    }


    /* =======================================================
       PLUS BUTTON
    ======================================================= */

    if (plusButton) {

      plusButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          event.stopPropagation();

          if (busy) {
            return;
          }


          const current =
            Number(
              item.quantity || 0
            );


          const newQuantity =
            current + 1;


          /*
            Shopify line item KEY.
          */

          changeLine(
            item.key,
            newQuantity
          );
        }
      );
    }


    /* =======================================================
       REMOVE
    ======================================================= */

    if (removeButton) {

      removeButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          event.stopPropagation();

          if (busy) {
            return;
          }


          changeLine(
            item.key,
            0
          );
        }
      );
    }


    /* =======================================================
       LOAD COMPARE AT PRICE
    ======================================================= */

    getMeta(item)
      .then(function (meta) {

        if (!meta) {
          return;
        }

        if (
          !document.body.contains(card)
        ) {
          return;
        }


        if (
          comparePrice &&
          meta.compareAt > unitPrice
        ) {

          comparePrice.textContent =
            money(
              meta.compareAt
            );

          comparePrice.hidden =
            false;
        }

      })
      .catch(function (error) {

        console.error(
          '[HousiousCart Meta]',
          error
        );
      });


    return fragment;
  }


  /* =========================================================
     RENDER CART
  ========================================================= */

  function render(cart) {

    cartData = cart;

    const sequence =
      ++renderSeq;


    itemsContainer.innerHTML =
      '';


    const hasItems =
      Array.isArray(cart.items) &&
      cart.items.length > 0;


    /*
      IMPORTANT:
      item_count = total quantity,
      not number of different products.
    */

    const totalQuantity =
      Number(
        cart.item_count || 0
      );


    /* =======================================================
       EMPTY STATE
    ======================================================= */

    if (emptyState) {

      emptyState.style.display =
        hasItems
          ? 'none'
          : 'flex';
    }


    /* =======================================================
       FOOTER
    ======================================================= */

    if (footer) {

      footer.style.display =
        hasItems
          ? 'block'
          : 'none';
    }


    /* =======================================================
       ITEMS
    ======================================================= */

    if (hasItems) {

      cart.items.forEach(
        function (item, index) {

          itemsContainer.appendChild(
            itemNode(
              item,
              index
            )
          );
        }
      );
    }


    /* =======================================================
       TIER
    ======================================================= */

    updateTier(
      totalQuantity
    );


    /* =======================================================
       HEADER COUNT
    ======================================================= */

    updateHeaderCount(
      totalQuantity
    );


    /* =======================================================
       SUBTOTAL + SUMMARY
    ======================================================= */

    updateSummary(
      cart,
      sequence
    ).catch(function (error) {

      console.error(
        '[HousiousCart Summary]',
        error
      );
    });
  }


  /* =========================================================
     FETCH CART
  ========================================================= */

  async function fetchCart() {

    const response =
      await fetch(
        '/cart.js',
        {
          credentials: 'same-origin',

          headers: {
            Accept:
              'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'Could not load cart'
      );
    }


    const cart =
      await response.json();


    render(cart);

    return cart;
  }


  /* =========================================================
     CHANGE QUANTITY
  ========================================================= */

  async function changeLine(
    lineKey,
    quantity
  ) {

    if (busy) {
      return;
    }


    if (!lineKey) {

      console.error(
        '[HousiousCart] Missing line item key'
      );

      return;
    }


    setBusy(true);


    /*
      Find current card.
    */

    const card =
      itemsContainer.querySelector(
        '[data-line-key="' +
        CSS.escape(
          String(lineKey)
        ) +
        '"]'
      );


    if (card) {

      card.classList.add(
        'is-updating'
      );
    }


    try {

      const response =
        await fetch(
          '/cart/change.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({

              /*
                Shopify accepts the
                line item key here.
              */

              id: lineKey,

              quantity:
                Number(quantity)
            })
          }
        );


      const cart =
        await response.json();


      if (!response.ok) {

        throw new Error(
          cart.description ||
          cart.message ||
          'Could not update quantity'
        );
      }


      /*
        Shopify returned the latest cart.
      */

      render(cart);


      /*
        Update header immediately.
      */

      updateHeaderCount(
        cart.item_count
      );


      /*
        Tell other theme scripts.
      */

      document.dispatchEvent(
        new CustomEvent(
          'cart:updated',
          {
            detail: {
              cart: cart
            }
          }
        )
      );


    } catch (error) {

      console.error(
        '[HousiousCart Quantity]',
        error
      );


      /*
        Re-sync with Shopify.
      */

      await fetchCart()
        .catch(function () {});


    } finally {

      setBusy(false);
    }
  }


  /* =========================================================
     ADD TO CART
  ========================================================= */

  async function addToCart(
    variantId,
    quantity = 1,
    options = {}
  ) {

    if (
      busy ||
      !variantId
    ) {
      return;
    }


    setBusy(true);


    const autoOpen =
      options.autoOpenDrawer !== false;


    if (autoOpen) {

      openDrawer(false);

      showLoadingState();
    }


    try {

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({

              id:
                Number(variantId),

              quantity:
                Number(quantity)
            })
          }
        );


      const data =
        await response
          .json()
          .catch(function () {
            return {};
          });


      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Could not add product'
        );
      }


      /*
        Always get the complete cart
        after adding.
      */

      const cart =
        await fetchCart();


      updateHeaderCount(
        cart.item_count
      );


    } catch (error) {

      console.error(
        '[HousiousCart Add]',
        error
      );


      if (autoOpen) {

        await fetchCart()
          .catch(function () {});
      }


    } finally {

      setBusy(false);
    }
  }


  /* =========================================================
     ADD MULTIPLE ITEMS
  ========================================================= */

  async function addItemsToCart(
    items = []
  ) {

    if (
      busy ||
      !items.length
    ) {
      return;
    }


    setBusy(true);

    openDrawer(false);

    showLoadingState();


    try {

      const response =
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',

            credentials:
              'same-origin',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items: items
            })
          }
        );


      if (!response.ok) {

        const errorData =
          await response
            .json()
            .catch(function () {
              return {};
            });

        throw new Error(
          errorData.description ||
          'Could not add products'
        );
      }


      const cart =
        await fetchCart();


      updateHeaderCount(
        cart.item_count
      );


    } catch (error) {

      console.error(
        '[HousiousCart Multiple Add]',
        error
      );


      await fetchCart()
        .catch(function () {});


    } finally {

      setBusy(false);
    }
  }


  /* =========================================================
     DISCOUNT
  ========================================================= */

  async function setDiscount(
    codes,
    message
  ) {

    const response =
      await fetch(
        '/cart/update.js',
        {
          method: 'POST',

          credentials:
            'same-origin',

          headers: {
            'Content-Type':
              'application/json',

            Accept:
              'application/json'
          },

          body: JSON.stringify({
            discount:
              codes.join(',')
          })
        }
      );


    if (!response.ok) {

      throw new Error(
        message
      );
    }


    return response.json();
  }


  /* =========================================================
     APPLY DISCOUNT
  ========================================================= */

  async function applyDiscount(
    code
  ) {

    code =
      String(code || '').trim();


    if (
      !code ||
      busy
    ) {
      return;
    }


    setBusy(true);

    feedback(
      'Applying code…',
      false
    );


    try {

      const existingCodes =
        appliedCodeObjects(
          cartData || {}
        )
          .map(function (discount) {
            return String(
              discount.code
            );
          })
          .filter(function (existing) {

            return existing.toLowerCase() !==
              code.toLowerCase();
          });


      existingCodes.push(code);


      const cart =
        await setDiscount(
          existingCodes,
          'Could not apply discount'
        );


      render(cart);


      const applied =
        appliedCodeObjects(cart)
          .some(function (discount) {

            return String(
              discount.code
            ).toLowerCase() ===
              code.toLowerCase();
          });


      feedback(
        applied
          ? code + ' applied.'
          : code +
            ' is not valid for this cart.',
        !applied
      );


    } catch (error) {

      console.error(
        '[HousiousCart Discount]',
        error
      );


      feedback(
        'Could not apply this code. Please try again.',
        true
      );


      await fetchCart()
        .catch(function () {});


    } finally {

      setBusy(false);
    }
  }


  /* =========================================================
     REMOVE DISCOUNT
  ========================================================= */

  async function removeDiscount(
    code
  ) {

    code =
      String(code || '').trim();


    if (
      !code ||
      busy
    ) {
      return;
    }


    setBusy(true);

    feedback(
      'Removing code…',
      false
    );


    try {

      const remaining =
        appliedCodeObjects(
          cartData || {}
        )
          .filter(function (discount) {

            return String(
              discount.code
            ).toLowerCase() !==
              code.toLowerCase();
          })
          .map(function (discount) {

            return String(
              discount.code
            );
          });


      const cart =
        await setDiscount(
          remaining,
          'Could not remove discount'
        );


      render(cart);


      feedback(
        code + ' removed.',
        false
      );


    } catch (error) {

      console.error(
        '[HousiousCart Remove Discount]',
        error
      );


      feedback(
        'Could not remove this code.',
        true
      );


      await fetchCart()
        .catch(function () {});


    } finally {

      setBusy(false);
    }
  }


  /* =========================================================
     OPEN DRAWER
  ========================================================= */

  async function openDrawer(
    fetchFirst = true
  ) {

    drawer.classList.add(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );


    overlay.classList.add(
      'is-active'
    );

    overlay.setAttribute(
      'aria-hidden',
      'false'
    );


    document.body.classList.add(
      'cart-drawer-open'
    );


    if (fetchFirst) {

      await fetchCart()
        .catch(function (error) {

          console.error(
            '[HousiousCart Fetch]',
            error
          );
        });
    }
  }


  /* =========================================================
     CLOSE DRAWER
  ========================================================= */

  function closeDrawer() {

    drawer.classList.remove(
      'is-open'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    overlay.classList.remove(
      'is-active'
    );

    overlay.setAttribute(
      'aria-hidden',
      'true'
    );


    document.body.classList.remove(
      'cart-drawer-open'
    );
  }


  /* =========================================================
     ADD TO CART FORM
  ========================================================= */

  document.addEventListener(
    'submit',
    async function (event) {

      const form =
        event.target.closest(
          '[data-type="add-to-cart-form"]'
        );


      if (!form) {
        return;
      }


      event.preventDefault();


      if (busy) {
        return;
      }


      const idInput =
        form.querySelector(
          'input[name="id"]'
        );


      const quantityInput =
        form.querySelector(
          'input[name="quantity"]'
        );


      const variantId =
        Number(
          idInput
            ? idInput.value
            : 0
        );


      const quantity =
        Number(
          quantityInput
            ? quantityInput.value
            : 1
        );


      const shouldAutoOpen =
        !(
          window.themeCartSettings &&
          window.themeCartSettings.autoOpen === false
        );


      if (variantId) {

        await addToCart(
          variantId,
          quantity,
          {
            autoOpenDrawer:
              shouldAutoOpen
          }
        );
      }
    }
  );


  /* =========================================================
     CART ICON / TOGGLE
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      const trigger =
        event.target.closest(
          '[data-cart-toggle]'
        );


      if (!trigger) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      openDrawer(true);
    }
  );


  /* =========================================================
     CLOSE
  ========================================================= */

  if (closeBtn) {

    closeBtn.addEventListener(
      'click',
      closeDrawer
    );
  }


  overlay.addEventListener(
    'click',
    closeDrawer
  );


  if (continueShopping) {

    continueShopping.addEventListener(
      'click',
      closeDrawer
    );
  }


  /* =========================================================
     ESCAPE
  ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        drawer.classList.contains(
          'is-open'
        )
      ) {

        closeDrawer();
      }
    }
  );


  /* =========================================================
     DISCOUNT REMOVE
  ========================================================= */

  if (appliedDiscounts) {

    appliedDiscounts.addEventListener(
      'click',
      function (event) {

        const button =
          event.target.closest(
            '[data-remove-discount]'
          );


        if (!button) {
          return;
        }


        removeDiscount(
          button.dataset.removeDiscount
        );
      }
    );
  }


  /* =========================================================
     SUGGESTED DISCOUNT
  ========================================================= */

  if (suggestedOfferApplyBtn) {

    suggestedOfferApplyBtn.addEventListener(
      'click',
      function () {

        const suggested =
          cfg.suggestedCoupon;


        if (
          suggested &&
          suggested.code
        ) {

          applyDiscount(
            suggested.code
          );
        }
      }
    );
  }


  /* =========================================================
     EXTERNAL CART UPDATE
  ========================================================= */

  document.addEventListener(
    'cart:updated',
    function (event) {

      /*
        If another theme script changed
        the cart, synchronize the drawer.
      */

      if (
        event &&
        event.detail &&
        event.detail.cart
      ) {

        render(
          event.detail.cart
        );

      } else if (!busy) {

        fetchCart()
          .catch(function () {});
      }
    }
  );


  /* =========================================================
     LOADING CSS
  ========================================================= */

  const style =
    document.createElement('style');


  style.textContent = `

    #cart-drawer-items
    .cart-drawer__loading {

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      gap: 14px;

      padding: 70px 20px;

      color: #666;

      font-size: 14px;
    }


    #cart-drawer-items
    .cart-drawer__spinner {

      width: 30px;
      height: 30px;

      border-radius: 50%;

      border: 3px solid rgba(0,0,0,0.1);

      border-top-color: #ff5600;

      animation:
        cart-drawer-spin
        .8s
        linear
        infinite;
    }


    .cart-item.is-updating {

      opacity: 0.6;
      pointer-events: none;
    }


    .cart-item__qty-btn:disabled,
    .cart-item__remove:disabled {

      opacity: 0.5;
      cursor: not-allowed;
    }


    @keyframes cart-drawer-spin {

      to {
        transform: rotate(360deg);
      }
    }

  `;


  document.head.appendChild(
    style
  );


  /* =========================================================
     PUBLIC CART API
  ========================================================= */

  window.CartDrawer = {

    open: function () {
      return openDrawer(true);
    },

    close: closeDrawer,

    addToCart: addToCart,

    addItemsToCart:
      addItemsToCart,

    fetchCart:
      fetchCart,

    changeLine:
      changeLine,

    applyDiscount:
      applyDiscount,

    removeDiscount:
      removeDiscount,

    updateHeaderCount:
      updateHeaderCount
  };


  /* =========================================================
     INITIAL HEADER COUNT
  ========================================================= */

  /*
    Load the real cart count as soon as
    the script initializes.

    This means your header counter is also
    correct after page refresh.
  */

  fetch(
    '/cart.js',
    {
      credentials: 'same-origin',
      headers: {
        Accept:
          'application/json'
      }
    }
  )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Could not initialize cart count'
        );
      }

      return response.json();
    })
    .then(function (cart) {

      cartData = cart;

      updateHeaderCount(
        cart.item_count
      );
    })
    .catch(function (error) {

      console.error(
        '[HousiousCart Initial Count]',
        error
      );
    });

})();